import React, {useEffect} from 'react'
import { Link } from "react-router-dom"
import "./NotFound.scss"; // Import SCSS file

const NotFound = () => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    }, []);
    return (
        <div>

            <div className="not-found">
                <h1>404</h1>
                <h2>Oops! Page Not Found</h2>
                <p>The page you are looking for doesn’t exist or has been moved.</p>
                <Link to="/" className="home-btn">Go Home</Link>
            </div>
        </div>
    )
}

export default NotFound